var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coursesSpeaking"},[(_vm.dialoguesData.length)?_c('router-view',{attrs:{"coursesDialogueInfo":_vm.coursesDialogueInfo,"dialoguesData":_vm.dialoguesData,"audio":_vm.audio}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }